export default "__VITE_ASSET__BLRIpF6u__"